import React, {Component} from 'react';
import EventListener from 'react-event-listener';
import {connect} from 'react-redux';

import trackPageView from 'topmeteo/google-analytics/page-view';

import {popState} from '../actionCreators';

class URLChanger extends Component {

    constructor(props) {
        super(props);

        this.stateDidPop = false;
        this.handlePopState = this.handlePopState.bind(this);
    }

    render() {
        return (
            <EventListener target={window} onPopState={this.handlePopState}>
                {this.props.children}
            </EventListener>
        );
    }

    handlePopState(event) {
        const {handlePopState, popState} = this.props;

        this.stateDidPop = true;

        return handlePopState(popState, event);
    }

    componentDidMount() {
        const {data, title, url} = this.props;

        history.replaceState(data, title, url);
    }

    componentDidUpdate() {
        const {data, title, url} = this.props;

        history.pushState(data, title, url);
        trackPageView(url);
    }

    shouldComponentUpdate({isDragging, isAnimating, url}) {
        /* Prevent pushing the last state on the history
           again after the history has changed. */
        if (this.stateDidPop) return this.stateDidPop = false;

        /* Force an update when dragging ends. */
        if (this.props.isDragging && isDragging === null) return true;

        /* Force an update when animation ends. */
        if (this.props.isAnimating && isAnimating === false) return true;

        return isDragging === null && isAnimating === false && url !== this.props.url;
    }

}

URLChanger.defaultProps = {
    popState,
    url: null,
    data: null,
    title: 'TopMeteo',
};

const mapStateToProps = ({isDragging, isAnimating}) => ({
    isDragging,
    isAnimating,
});

const mapDispatchToProps = dispatch => ({
    handlePopState: (popState, {state}) => dispatch(popState(state)),
});

export default connect(mapStateToProps, mapDispatchToProps)(URLChanger);
